import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/terms-of-use/hero";
import PP from "../components/terms-of-use/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>
          Same Day Smile Full Arch Implant Dentistry in Ilkley West Yorkshire
        </title>
        <meta
          name="description"
          content="Read the Terms of Use for Same Day Smile Ilkley. Understand your rights and responsibilities when accessing our website, services, and dental information online."
        />
        <link
          rel="canonical"
          href="https://www.samedaysmile-ilkley.com/terms-of-use"
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
